import { AvForm } from 'availity-reactstrap-validation';
import { Button, Card, CardBody, Col, FormGroup, Row } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';

import AiSeedSection from './AiSeedSection';
import GeneratedFormSection from './GeneratedFormSection';
import { getGeneratedFormSections } from '../constants/fieldDefinitions';

const CarrierAiForm = ({
    t,
    lng,
    values,
    countriesList,
    aiFieldsVisible,
    isAiLoading,
    canGenerate,
    isSubmitting,
    onFieldChange,
    onGenerateWithAi,
    onRefreshAi,
    onCreateClick,
}) => {
    const generatedSections = getGeneratedFormSections(values.type, values);

    return (
        <AvForm
            className="needs-validation"
            onValidSubmit={(event) => {
                event.preventDefault();
            }}
            autocomplete="off"
        >
            <AiSeedSection
                t={t}
                lng={lng}
                values={values}
                countriesList={countriesList}
                isAiLoading={isAiLoading}
                canGenerate={canGenerate}
                onFieldChange={onFieldChange}
                onGenerateWithAi={onGenerateWithAi}
            />

            {aiFieldsVisible && (
                <Card className="wizard-steps-content-container ai-generated-form-section mt-4">
                    <CardBody className="p-0">
                        <div className="ai-generated-form-section__header">
                            <h5 className="mb-1">{t('Third Party Details')}</h5>
                            <p className="text-muted mb-0">
                                {t('Review and edit the AI-generated information below. All fields remain fully editable.')}
                            </p>
                        </div>

                        {generatedSections.map((section) => (
                            <GeneratedFormSection
                                key={section.key}
                                section={section}
                                values={values}
                                t={t}
                                lng={lng}
                                countriesList={countriesList}
                                onChange={onFieldChange}
                            />
                        ))}

                        {!isAiLoading && (
                            <div className="mb-4">
                                <Button
                                    color="link"
                                    className="p-0"
                                    type="button"
                                    onClick={onRefreshAi}
                                >
                                    {t('Refresh from AI')}
                                </Button>
                            </div>
                        )}
                    </CardBody>
                </Card>
            )}

            {aiFieldsVisible && (
                <Row className="mt-2 mb-4">
                    <Col sm="12">
                        <FormGroup
                            style={{
                                display: 'flex',
                                flexFlow: 'row wrap',
                                justifyContent: 'flex-end',
                            }}
                            className="actions-buttons-container"
                        >
                            <Button
                                color="primary"
                                type="button"
                                disabled={isSubmitting || isAiLoading}
                                onClick={onCreateClick}
                            >
                                {t('Create Third Party')}
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            )}
        </AvForm>
    );
};

export default CarrierAiForm;
